"use strict";
'use es6';

function hs_i18n_log(message) {
  console.log("i18n_getmessage: " + message);
}

function hs_i18n_substituteStrings(str, subs) {
  var tokens = str.match(new RegExp("\\$[0-9]+", "g"));
  if (tokens == null) {
    return str;
  }

  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    var subIndex = parseInt(token.replace("$", ""));
    if (subIndex <= 0 || subs == null || subIndex > subs.length) {
      hs_i18n_log("no substitution string at index " + subIndex + " found for string '" + str + "'");
    } else {
      str = str.replace(token, subs[subIndex - 1]);
    }
  }
  return str;
}

function hs_i18n_insertPlaceholders(message, subs) {
  var result = message.message;

  var tokens = result.match(new RegExp("\\$\\w+\\$", "g"));
  if (tokens == null) {
    return result;
  }

  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    var plainToken = token.replace(new RegExp("\\$", "g"), "").toLowerCase();
    var placeholder = message.placeholders[plainToken];
    if (placeholder == null) {
      hs_i18n_log("no placeholder found for '" + plainToken + "'");
    }
    result = result.replace(token, placeholder.content);
  }

  result = hs_i18n_substituteStrings(result, subs);
  return result.replace(/\$\$/g, "$");
}

function hs_i18n_getMessage(messages, language) {

  if (messages == null) {
    hs_i18n_log("no messages found");
    return "";
  }

  var args = arguments[2];
  if (args == null || args.length == 0 || args[0] == null) {
    hs_i18n_log("no message name passed");
    return "";
  }

  var messageName = args[0];
  var region = language.split("-")[0];

  var languageStrings = languageStrings == null && region != language ? messages[region] : messages[language];
  if (languageStrings == null) {
    hs_i18n_log("no messages found for language '" + language + "'");
    return "";
  }

  var message = message == null && region != language ? messages[region][messageName] : languageStrings[messageName];
  if (message == null) {
    hs_i18n_log("no message found for language '" + language + "' named '" + messageName + "'");
    return "";
  }

  return hs_i18n_insertPlaceholders(message.placeholders, args[1]);
}

